import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Enlightenment_&_Revolutions_-_French_Revolution.png';

function HistoryPageFrenchRevolution() {
  return (
    <TopicPage
      topicKey="French Revolution"
      title="History: French Revolution"
      backgroundImage={bg}
      startRoute="/History-French-Revolution-Go"
      scrollLabels={[
        "Fall of the Monarchy",
        "Reign of Terror",
        "Rise of Napoleon"
      ]}
      backRoute="/history-age-of-revolutions"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageFrenchRevolution;
